import { EffectRepository } from "@/modules/effects/domain/EffectRepository";
import { Effect } from "@/modules/effects/domain/Effect";
import { EffectFilters } from "@/modules/effects/domain/EffectFilters";
import { CompanyEffectsConfiguration } from "@/modules/effects/domain/CompanyEffectsConfiguration";
import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { query_dispatcher, sync_command_dispatcher, async_command_dispatcher } from "@/api/client";

export class ApiEffectRepository implements EffectRepository{

    command_dispatcher: CommandDispatcher
    async_command_dispatcher: CommandDispatcher
    query_dispatcher: QueryDispatcher
    constructor(){
        this.command_dispatcher = sync_command_dispatcher
        this.async_command_dispatcher = async_command_dispatcher
        this.query_dispatcher = query_dispatcher
    }        

    api_to_domain(line){
        return new Effect(line.id, line.date, line.amount, line.amount_no_punteado, line.account, line.company_id, line.state, line.concept, line.effect_type, line.invoice_number, line.origin_id, line.origin, line.deleted, line.due_date)
    }
    
    async filter_by_company_id(company_id: number, filters:EffectFilters|null):Promise<Effect[]|null>{
      let args = {
        company_id: company_id
      }
      args['filters'] = {}
      if (filters) {
        for (const key of Object.keys(filters)) {
          if (filters[key as keyof EffectFilters] && filters[key as keyof EffectFilters] != '') {
            args['filters'][key] = filters[key as keyof EffectFilters];
          }
        }
      }
      
      let effects = await this.query_dispatcher.dispatch('company.effects', args)      
      if(effects.results) {
          return effects.results.map(line => this.api_to_domain(line), this)
      }
      else {
          return []
      }        
    }

    async get_pending_effects(company_id: number, transaction_id:string|null, filters:EffectFilters|null): Promise<Effect[]> {
      let args = {
        company_id: company_id
      }
      if (transaction_id) {
        args['transaction_id'] = transaction_id;
      }
      args['filters'] = {}
      if (filters) {
        for (const key of Object.keys(filters)) {
          if (filters[key as keyof EffectFilters] && filters[key as keyof EffectFilters] != '') {
            args['filters'][key] = filters[key as keyof EffectFilters];
          }
        }
      }
      
      let effects = await this.query_dispatcher.dispatch('pending.effects', args)
      return effects.results.map(line => this.api_to_domain(line), this)   
    }

    async import_effects(company_id: number, min_date:string, max_date:string):Promise<number>{      
        let args = { 
          company_id: company_id,
          date_from:min_date,
          date_to: max_date     
        }    
        let res = await this.async_command_dispatcher.dispatch('import.effects.data', args)        
        return res.job_id
    }
    
    async delete(effects_ids: number[]): Promise<void> {
      let args = {
        effects_ids: effects_ids
      }
      await this.command_dispatcher.dispatch('delete.effects', args)
    }

    async toggle_manual_check(effects_ids: number[], mark_as_checked: boolean): Promise<any> {
      let args = {
        effects_ids: effects_ids,
        mark_as_checked: mark_as_checked
      }
      return await this.command_dispatcher.dispatch('toggle.effects.manual.check', args)
    }

    async import_effects_accounting_program(company_id: number, min_date:string, max_date:string):Promise<void>{ 
      let args = { 
        company_id: company_id,
        min_date: min_date,
        max_date: max_date     
      }
      
      await this.command_dispatcher.dispatch('launch_operation.upload_effects', args)
    }

    async upload_effects_file(company_id: number, file_path: string, og_file_name: string): Promise<number> {
      let args = {
        company_id: company_id,
        file_path: file_path,
        og_file_name: og_file_name
      }
      let res = await this.async_command_dispatcher.dispatch('upload.effects.from.excel', args)
      return res.job_id
    }

    async update_effects_configuration(company_id:number, effects_config:CompanyEffectsConfiguration):Promise<void> { 
      let args = {
        company_id: company_id,
        effects_origin: effects_config.effects_origin,
        automatic_effects_inmatic: effects_config.automatic_effects_inmatic
      }
      await this.command_dispatcher.dispatch('update.company.effects.configuration', args)
    }

    async get_effects_configuration(company_id:number):Promise<CompanyEffectsConfiguration> {
      let args = {
        company_id: company_id
      }
      let res = await this.query_dispatcher.dispatch('get.company.configuration', args)
      return new CompanyEffectsConfiguration(res.data.effects_origin, res.data.automatic_effects_inmatic)
    }

    async create_effect_manual(company_id:number, amount:number, account:string, concept:string, effect_type:string, invoice_number:string, date:string):Promise<void> {
      let args = {
        company_id: company_id,
        amount: amount,
        account: account,
        concept: concept,
        effect_type: effect_type,
        invoice_number: invoice_number,
        date: date
      }
      await this.command_dispatcher.dispatch('create.effect.manual', args)
    }
  }